<form>
    <app-form-section [formGroup]="realEstateForm">
        <app-form-row-header [title]="'FEATURES.AGREEMENTS.GROUP_TITLE_REALESTATE' | translate" icon="apartment" />
        <div class="form">
            <app-form-row>
                <app-form-group>
                    <label for="propertyNo">{{ 'FEATURES.AGREEMENTS.PROPERTY_NO' | translate }}</label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="propertyNo"
                        formControlName="propertyNo"
                        type="text"
                    />
                </app-form-group>
                <app-form-group>
                    <label for="apartmentNo">{{ 'FEATURES.AGREEMENTS.APARTMENT_NO' | translate }}</label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="apartmentNo"
                        formControlName="apartmentNo"
                        type="text"
                    />
                </app-form-group>
            </app-form-row>
            <app-form-row>
                <app-form-group>
                    <label for="size">{{ 'FEATURES.AGREEMENTS.SIZE' | translate }}</label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="size"
                        formControlName="size"
                        type="number"
                        min="0"
                    />
                </app-form-group>
                <app-form-group>
                    <label for="typeOfPremises">{{ 'FEATURES.AGREEMENTS.TYPE_OF_PREMISES' | translate }}</label>
                    <div>
                        <app-listtype-select
                            formControlName="typeOfPremises"
                            listType="TYPE_OF_PREMISES"
                            [showPotentialValidationMessages]="true"
                        />
                    </div>
                </app-form-group>
            </app-form-row>
        </div>
    </app-form-section>
</form>
